export default __webpack_public_path__ + "static/media/elevate-cbb-banner-3.f60fc574.jpg";